import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** Legacy draw / your-turn routes redirect to Taboo game. */
export default function RedirectToGame() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    navigate("/game", { replace: true, state: location.state });
  }, [navigate, location.state]);
  return null;
}
